module.exports = __webpack_public_path__ + "static/ads-shadow-e2e318a4c9fd09ea0fe345902add12ba.jpg";